export {generateClassName, jss} from '@makolab/library-react/dist/jssConfig';



// WEBPACK FOOTER //
// ./src/styles/jss-config.js